//Guide https://www.loqate.com/resources/support/setup-guides/advanced-setup-guide/

window.addEventListener( "load", function( )
{
        var loqateCountryCodes = "GB,GE,JY"
        var fields = [
                // { element: "swatch-input-address1", field: "Line1" },
                { element: "search_input", field: "PostalCode" },
                { element: "address_line_1", field: "Line1", mode: pca.fieldMode.POPULATE },
                { element: "address_line_2", field: "Line2", mode: pca.fieldMode.POPULATE },
                { element: "city", field: "City", mode: pca.fieldMode.POPULATE },
                { element: "post_code", field: "PostalCode", mode: pca.fieldMode.POPULATE },
                { element: "country", field: "CountryName", mode: pca.fieldMode.POPULATE }, 

        ];
        var options =
        {
            "key" : "RY19-ME54-AM99-RZ49",
            "setCountryByIP" : true,
            "countries": { codesList: loqateCountryCodes }
        };
        var control = new pca.Address( fields, options );

        console.log( control );
} );